import classNames from "classnames";
import {isValid, parseISO} from "date-fns";

import {ShortDateUser} from "@/components/datetime/ShortDateUser.tsx";
import {ShortTimeUser} from "@/components/datetime/ShortTimeUser.tsx";
import {AccountUser} from "@/lib/types/accounts.ts";

type TwoLineShortDateTimeUserProps = {
  date: string;
  user: AccountUser;
  dateClassName?: classNames.ArgumentArray | string;
  timeClassName?: classNames.ArgumentArray | string;
};

export const TwoLineShortDateTimeUser = ({
  date,
  user,
  dateClassName,
  timeClassName = "pulse-color-gray-600",
}: TwoLineShortDateTimeUserProps) => {
  const dateObj = parseISO(date);
  if (!isValid(dateObj)) return null;
  return (
    <>
      <ShortDateUser
        date={dateObj}
        timezone={user.account.timezone}
        dateFormat={user.current_date_format}
        className={dateClassName}
      />
      <ShortTimeUser
        date={dateObj}
        timezone={user.account.timezone}
        timeFormat={user.current_time_format}
        className={timeClassName}
      />
    </>
  );
};
